import React from "react";
import { useRBA } from "../../Hook/useRBA";
import type { PolicyPath } from "../../Types";

interface RBASwitchProps {
  policy: PolicyPath;
  onEnabled: React.ReactNode;
  onDisabled: React.ReactNode;
}

export const RBASwitch: React.FC<RBASwitchProps> = ({ policy, onEnabled, onDisabled }) => {
  const { isAllowed } = useRBA();

  if (isAllowed(policy)) {
    return <>{onEnabled}</>;
  }

  return <>{onDisabled}</>;
};
